/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */
import React from "react";
import PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {BLOCKS, INLINES} from "@contentful/rich-text-types";
import {documentToReactComponents} from "@contentful/rich-text-react-renderer";
import {retrieveContentfulImage} from "../../../common/image";
import {COMMON_URL_SUFFIX} from "../../../common/constant";

const useStyles = makeStyles(theme => ({
    hyperlink: {
        color: theme.palette.black,
        fontWeight: "600",
        cursor: "pointer",
        textDecoration: "underline",
        whiteSpace: "pre-wrap",
        wordWrap: "break-word",
        "&:hover": {
            textDecoration: "underline"
        },
    },
    img: {
        maxWidth: "100%"
    }
}));



const CustomRichText = ({document, assets, renderNodeOverride, links}) => {
    const classes = useStyles();

    const renderNodeOptions = {
        [BLOCKS.HEADING_1]: (node, children) => (
            <Typography
                variant={"h1"}
            >
                {children}
            </Typography>
        ),
        [BLOCKS.HEADING_2]: (node, children) => (
            <Typography
                variant={"h2"}
            >
                {children}
            </Typography>
        ),

        [BLOCKS.HEADING_3]: (node, children) => (
            <Typography
                variant={"h3"}
            >
                {children}
            </Typography>
        ),

        [BLOCKS.HEADING_4]: (node, children) => (
            <Typography
                variant={"h4"}
            >
                {children}
            </Typography>
        ),

        [BLOCKS.HEADING_5]: (node, children) => (
            <Typography
                variant={"h5"}
            >
                {children}
            </Typography>
        ),

        [BLOCKS.HEADING_6]: (node, children) => (
            <Typography
                variant={"h6"}
            >
                {children}
            </Typography>
        ),
        [BLOCKS.PARAGRAPH]: (node, children) => (
            <Typography
                variant={"body1"}
            >
                {children}
            </Typography>
        ),
        [INLINES.HYPERLINK]: (node, children) => (
            <a
                href={node?.data?.uri}
                className={classes.hyperlink}
                target={node?.data?.uri?.indexOf(COMMON_URL_SUFFIX) >= 0 ? "_self" : "_blank"}
            >
                {children}
            </a>
        ),
        [INLINES.ASSET_HYPERLINK]: (node, children) => {
            return (
                <a
                    // href={links?.assets?.block?.sys?.id}
                    className={classes.hyperlink}
                    target={node?.data?.uri?.indexOf(COMMON_URL_SUFFIX) >= 0 ? "_self" : "_blank"}
                >
                    {children}
                </a>
            );
        },
        [BLOCKS.EMBEDDED_ASSET]: (node) => (
            <img
                src={retrieveContentfulImage(assets?.block?.find(entry => entry?.sys?.id === node.data.target.sys.id)?.url)}
                className={classes.img}
            />
        ),
    };

    const renderTextOption = {
        renderText: (text) => {
            const curlyBracesRegex = /##(.*?)##/g;

            return text.split(curlyBracesRegex).map((part, index) =>
                index % 2 !== 0 ? ( // Odd indexes contain the match
                    <span
                        key={index}
                        style={{ color: "red", fontWeight: "bold" }}
                    >
                        {part}
                    </span>
                ) : (
                    part
                )
            );
        },
    };

    return (
        <>
            {document && documentToReactComponents(document, {
                renderNode: {
                    ...renderNodeOptions,
                    ...renderNodeOverride
                },
                ...renderTextOption
            })}
        </>
    );
};

CustomRichText.defaultProps = {
    renderNodeOverride: {}
};

CustomRichText.propTypes = {
    document: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
    assets: PropTypes.object,
    renderNodeOverride: PropTypes.object,
    links: PropTypes.object
};

export default CustomRichText;
